var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useFormik } from 'formik';
import { useRequest } from '../../../hooks/requestHook';
import { transportToWarehouse as api } from '../../../api';
import { useNotify } from '../../../hooks/notificationHook';
import { camelize } from '../../../utils/camelize';
import { Grid } from '@mui/material';
import { FormikTextField } from '../../atoms/TextField';
import PageSubmitButton from '../../molecules/PageSubmitButton';
import FormikDateTimePicker from '../../atoms/FormikDateTimePicker';
import { FormikSelectField } from '../../atoms/SelectField';
import { EstimatedDeliveryPeriodMonthParts, StatusValues, } from '../../../constants/transportToWarehouseValues';
import useFormikTextField from '../../../hooks/hoc/useFormikTextField';
import CurrencyTextField from '../../organisms/CurrencyTextField';
import { YearItems } from '../../../constants/date';
import { MonthItems } from '../../../constants/date';
var REQUIRED_FIELDS = ['status'];
var TransportToWarehouseForm = function (_a) {
    var offerList = _a.offerList, transportToWarehouse = _a.transportToWarehouse, onUpdated = _a.onUpdated;
    var t = useTranslation().t;
    var notify = useNotify();
    var update = useRequest(api.update);
    var _b = React.useState(false), loading = _b[0], setLoading = _b[1];
    var onSubmit = React.useCallback(function (values) { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoading(true);
                    return [4 /*yield*/, update({
                            id: transportToWarehouse.id,
                            offerListId: offerList.id,
                            transport_to_warehouse: values,
                        })];
                case 1:
                    response = _a.sent();
                    setLoading(false);
                    if (!response)
                        return [2 /*return*/];
                    notify('success', [t('messages.updateSuccess')]);
                    onUpdated(response);
                    return [2 /*return*/];
            }
        });
    }); }, [t, update, notify, transportToWarehouse, offerList, onUpdated]);
    var validate = React.useCallback(function (values) {
        var errors = {};
        REQUIRED_FIELDS.forEach(function (field) {
            if (values[field] === null ||
                values[field] === undefined ||
                values[field] === '') {
                errors[field] = t('errors.isRequired', {
                    field: t("params.warehouse.".concat(camelize(field))),
                });
            }
        });
        return errors;
    }, [t]);
    var formik = useFormik({
        initialValues: toFormikValue(transportToWarehouse),
        onSubmit: onSubmit,
        validate: validate,
        validateOnMount: true,
        validateOnChange: true,
        enableReinitialize: true,
    });
    var statusItems = React.useMemo(function () {
        return StatusValues.map(function (value) { return ({
            value: value,
            text: t("params.transportToWarehouse.statuses.".concat(camelize(value))),
        }); });
    }, [t]);
    var FormikCurrencyTextField = useFormikTextField(CurrencyTextField);
    var currency = React.useMemo(function () { return transportToWarehouse.currency; }, [transportToWarehouse.currency]);
    var monthPartItems = React.useMemo(function () {
        return EstimatedDeliveryPeriodMonthParts.map(function (value) { return ({
            value: value,
            text: t("params.transportToWarehouse.estimatedDeliveryPeriodMonthParts.".concat(camelize(value))),
        }); });
    }, [t]);
    return (React.createElement("form", { onSubmit: formik.handleSubmit },
        React.createElement(Grid, { container: true, spacing: 2 },
            React.createElement(Grid, { item: true, xs: 12, md: 3 },
                React.createElement(FormikSelectField, { fullWidth: true, name: "status", label: t('params.transportToWarehouse.status'), items: statusItems, required: true, formik: formik })),
            React.createElement(Grid, { item: true, xs: 12, md: 3 },
                React.createElement(FormikTextField, { fullWidth: true, name: "import_tax_rate", label: t('params.transportToWarehouse.importTaxRate'), required: true, formik: formik })),
            React.createElement(Grid, { item: true, xs: 12, md: 3 },
                React.createElement(FormikDateTimePicker, { fullWidth: true, ampm: false, name: "exported_at", label: t('params.exportedAt'), formik: formik })),
            React.createElement(Grid, { item: true, xs: 12, md: 3 },
                React.createElement(FormikDateTimePicker, { fullWidth: true, ampm: false, name: "imported_at", label: t('params.importedAt'), formik: formik, disabled: Boolean(transportToWarehouse.importedAt) })),
            React.createElement(Grid, { item: true, xs: 12, md: 3 },
                React.createElement(FormikCurrencyTextField, { fullWidth: true, currency: currency, name: "simulation_shipping_fee_unit_price", label: t('params.transportToWarehouse.simulationShippingFeeUnitPrice'), formik: formik })),
            React.createElement(Grid, { item: true, xs: 12, md: 3 },
                React.createElement(FormikCurrencyTextField, { fullWidth: true, currency: currency, name: "simulation_misc_fee_unit_price", label: t('params.transportToWarehouse.simulationMiscFeeUnitPrice'), formik: formik })),
            React.createElement(Grid, { item: true, xs: 12, md: 3 },
                React.createElement(FormikCurrencyTextField, { fullWidth: true, currency: currency, name: "simulation_taxed_misc_fee_unit_price", label: t('params.transportToWarehouse.simulationTaxedMiscFeeUnitPrice'), formik: formik })),
            React.createElement(Grid, { item: true, xs: 12, md: 3 }),
            React.createElement(Grid, { item: true, xs: 12, md: 3 },
                React.createElement(FormikCurrencyTextField, { fullWidth: true, currency: currency, name: "fixed_shipping_fee_unit_price", label: t('params.transportToWarehouse.fixedShippingFeeUnitPrice'), formik: formik })),
            React.createElement(Grid, { item: true, xs: 12, md: 3 },
                React.createElement(FormikCurrencyTextField, { fullWidth: true, currency: currency, name: "fixed_misc_fee_unit_price", label: t('params.transportToWarehouse.fixedMiscFeeUnitPrice'), formik: formik })),
            React.createElement(Grid, { item: true, xs: 12, md: 3 },
                React.createElement(FormikCurrencyTextField, { fullWidth: true, currency: currency, name: "fixed_taxed_misc_fee_unit_price", label: t('params.transportToWarehouse.fixedTaxedMiscFeeUnitPrice'), formik: formik })),
            React.createElement(Grid, { item: true, xs: 12, md: 3 }),
            React.createElement(Grid, { item: true, xs: 12 },
                React.createElement(FormikTextField, { fullWidth: true, name: "tracking_url", label: t('params.transportToWarehouse.trackingUrl'), formik: formik })),
            React.createElement(Grid, { item: true, xs: 12 },
                React.createElement(FormikTextField, { fullWidth: true, name: "note", label: t('params.transportToWarehouse.note'), multiline: true, rows: 3, formik: formik })),
            React.createElement(Grid, { item: true, xs: 12, md: 3 },
                React.createElement(FormikTextField, { fullWidth: true, type: "number", name: "export_moisture_content", label: t('params.transportToWarehouse.exportMoistureContent'), inputProps: { max: 99.9, min: 0, step: 0.1, maxLength: 4 }, formik: formik })),
            React.createElement(Grid, { item: true, xs: 12, md: 3 },
                React.createElement(FormikTextField, { fullWidth: true, type: "number", name: "export_water_activity", label: t('params.transportToWarehouse.exportWaterActivity'), inputProps: { max: 0.99, min: 0, step: 0.01, maxLength: 4 }, formik: formik })),
            React.createElement(Grid, { item: true, xs: 12, md: 3 },
                React.createElement(FormikTextField, { fullWidth: true, type: "number", name: "import_moisture_content", label: t('params.transportToWarehouse.importMoistureContent'), inputProps: { max: 99.9, min: 0, step: 0.1, maxLength: 4 }, formik: formik })),
            React.createElement(Grid, { item: true, xs: 12, md: 3 },
                React.createElement(FormikTextField, { fullWidth: true, type: "number", name: "import_water_activity", label: t('params.transportToWarehouse.importWaterActivity'), inputProps: { max: 0.99, min: 0, step: 0.01, maxLength: 4 }, formik: formik })),
            React.createElement(Grid, { item: true, xs: 12, md: 3 },
                React.createElement(FormikSelectField, { fullWidth: true, name: "estimated_delivery_period_year", label: t('params.transportToWarehouse.estimatedDeliveryPeriodYear'), items: YearItems, formik: formik })),
            React.createElement(Grid, { item: true, xs: 12, md: 3 },
                React.createElement(FormikSelectField, { fullWidth: true, name: "estimated_delivery_period_month", label: t('params.transportToWarehouse.estimatedDeliveryPeriodMonth'), items: MonthItems, formik: formik })),
            React.createElement(Grid, { item: true, xs: 12, md: 3 },
                React.createElement(FormikSelectField, { fullWidth: true, name: "estimated_delivery_period_month_part", label: t('params.transportToWarehouse.estimatedDeliveryPeriodMonthPart'), items: monthPartItems, formik: formik })),
            React.createElement(Grid, { item: true, xs: 12, md: 3 }),
            React.createElement(Grid, { item: true, xs: 12, md: 3 },
                React.createElement(FormikDateTimePicker, { fullWidth: true, ampm: false, name: "beans_paid_at", label: t('params.transportToWarehouse.beansPaidAt'), formik: formik })),
            React.createElement(Grid, { item: true, xs: 12, md: 3 },
                React.createElement(FormikDateTimePicker, { fullWidth: true, ampm: false, name: "misc_fees_paid_at", label: t('params.transportToWarehouse.miscFeesPaidAt'), formik: formik })),
            React.createElement(Grid, { item: true, xs: 12, md: 3 },
                React.createElement(FormikDateTimePicker, { fullWidth: true, ampm: false, name: "shipping_fee_paid_at", label: t('params.transportToWarehouse.shippingFeePaidAt'), formik: formik })),
            React.createElement(Grid, { item: true, xs: 12, md: 3 },
                React.createElement(FormikDateTimePicker, { fullWidth: true, ampm: false, name: "import_tax_paid_at", label: t('params.transportToWarehouse.importTaxPaidAt'), formik: formik })),
            React.createElement(Grid, { item: true, xs: 12 },
                React.createElement(PageSubmitButton, { disabled: !formik.isValid || loading }, t('buttons.update'))))));
};
export default TransportToWarehouseForm;
var toFormikValue = function (transportToWarehouse) {
    var _a, _b, _c;
    return ({
        status: transportToWarehouse.status,
        import_tax_rate: transportToWarehouse.importTaxRate,
        exported_at: transportToWarehouse.exportedAt,
        imported_at: transportToWarehouse.importedAt,
        note: transportToWarehouse.note,
        tracking_url: transportToWarehouse.trackingUrl,
        simulation_shipping_fee_unit_price: transportToWarehouse.simulationShippingFeeUnitPrice,
        simulation_misc_fee_unit_price: transportToWarehouse.simulationMiscFeeUnitPrice,
        simulation_taxed_misc_fee_unit_price: transportToWarehouse.simulationTaxedMiscFeeUnitPrice,
        fixed_shipping_fee_unit_price: transportToWarehouse.fixedShippingFeeUnitPrice,
        fixed_misc_fee_unit_price: transportToWarehouse.fixedMiscFeeUnitPrice,
        fixed_taxed_misc_fee_unit_price: transportToWarehouse.fixedTaxedMiscFeeUnitPrice,
        export_moisture_content: transportToWarehouse.exportMoistureContent,
        export_water_activity: transportToWarehouse.exportWaterActivity,
        import_moisture_content: transportToWarehouse.importMoistureContent,
        import_water_activity: transportToWarehouse.importWaterActivity,
        estimated_delivery_period_year: (_a = transportToWarehouse.estimatedDeliveryPeriodYear) !== null && _a !== void 0 ? _a : '',
        estimated_delivery_period_month: (_b = transportToWarehouse.estimatedDeliveryPeriodMonth) !== null && _b !== void 0 ? _b : '',
        estimated_delivery_period_month_part: (_c = transportToWarehouse.estimatedDeliveryPeriodMonthPart) !== null && _c !== void 0 ? _c : '',
        beans_paid_at: transportToWarehouse.beansPaidAt,
        misc_fees_paid_at: transportToWarehouse.miscFeesPaidAt,
        shipping_fee_paid_at: transportToWarehouse.shippingFeePaidAt,
        import_tax_paid_at: transportToWarehouse.importTaxPaidAt,
    });
};
